<template>
  <section
    role="note"
    :class="$style.card"
  >
    <div :class="$style.header">
      <div :class="$style['icon-container']">
        <bg-icon
          size="md"
          :color="theme.iconColor"
          :name="icon"
          :class="$style.icon"
        />
      </div>
    </div>
    <div :class="$style['content-container']">
      <slot />
    </div>
  </section>
</template>

<script setup>
import { BgIcon } from '@transfeeradev/bridge';
import { computed } from 'vue';

const props = defineProps({
  color: {
    type: String,
    required: true,
    validator: value => ['green', 'yellow', 'grey', 'red', 'blue'].includes(value)
  },
  icon: {
    type: String,
    required: true
  }
});

const theme = computed(() => {
  return {
    green: { backgroundColor: 'green-light', iconColor: 'green-semi-dark' },
    yellow: { backgroundColor: 'yellow-light', iconColor: 'yellow-semi-dark' },
    grey: { backgroundColor: 'grey-light', iconColor: 'grey-semi-dark' },
    red: { backgroundColor: 'red-light', iconColor: 'red-semi-dark' },
    blue: { backgroundColor: 'blue-light', iconColor: 'blue-semi-dark' }
  }[props.color];
});
</script>

<style scoped module>
.card {
  position: relative;
  display: flex;
  border: 1px solid var(--bg-grey-light);
  border-radius: var(--bg-border-radius-md);
  background-color: var(--bg-grey-white);
  padding: var(--bg-spacing-sm);
  flex-direction: row;
  gap: var(--bg-spacing-sm);
  flex-grow: 1;
}

.content-container {
  text-align: left;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  border-radius: var(--bg-border-radius-md);
  background-color: v-bind('`var(--bg-${theme.backgroundColor})`');
}

.icon {
  z-index: 1;
}

.header {
  display: flex;
  gap: var(--bg-spacing-sm);
}
</style>
